export const environment = {
  production: true,
  urlBE: 'https://gestionale.smafservices.it/api/',
  urlFE: 'https://gestionale.smafservices.it/',
  msalConfig: {
    auth: {
      clientId: '',
      authority: '',
    },
  },
  apiConfig: {
    scopes: ['User.Read Directory.Read.All'],
    uri: '',
  },
  secretKeyCryptJs:
    '9a8df2d28882c94b2fe8a5dc579a20630f15f405bd5f84f29b56353f3f21c555',
  version: 'v. 0.0.0',
};
